module.exports = __webpack_public_path__ + "img/gift13.82452380.png";